import React, {useCallback, useEffect, useRef} from 'react';
import './Iframe.scss';

type IFrameProps = {
  assetUrl: string;

  onFulfilled?: () => void;
  onTrackingInitialised?: () => void;
};

const IFrameTrackingLoadedEventMessage = 'loaded';
const IFrameTrackingCompletedEventMessage = 'completed';
export const IFrame: React.FC<IFrameProps> = ({ onTrackingInitialised, assetUrl, onFulfilled }) => {
  const ref = useRef<HTMLIFrameElement | null>(null);
  const handlePostMessages = useCallback(
    (event: MessageEvent) => {
      const messageFromChildIframe = ref.current && event.source === ref.current?.contentWindow;
      if (!messageFromChildIframe) {
        return;
      }
      switch (event.data) {
        case IFrameTrackingLoadedEventMessage:
          onTrackingInitialised?.();
          break;
        case IFrameTrackingCompletedEventMessage:
          onFulfilled?.();
          break;
      }
    },
    [onFulfilled, onTrackingInitialised]
  );
  useEffect(() => {
    window.addEventListener('message', handlePostMessages);
    return () => {
      window.removeEventListener('message', handlePostMessages);
    };
  }, [handlePostMessages]);

  return (
    <div className="iframe__container">
      <div className="iframe__wrapper">
        <iframe
          ref={ref}
          width="100%"
          height="100%"
          title="HTML widget"
          className="iframe"
          src={assetUrl}
          sandbox="allow-scripts"
        />
      </div>
    </div>
  );
};
